import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    // User is not logged in, redirect to login
    return <Navigate to="/" replace />;
  }

  // User is authenticated, render the children component
  return children;
};

export default ProtectedRoute;
